var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.835 3.94616L14 0L0.143616 8V24L14 32L27.8564 24V8L25.1651 6.44616L16.5311 21.4007C15.184 23.734 11.8161 23.734 10.4689 21.4007L6.33496 14.2404C5.6446 13.0447 6.05429 11.5157 7.25002 10.8254C8.44575 10.135 9.97473 10.5447 10.6651 11.7404L13.5 16.6507L20.835 3.94616Z",
    fill: "#DFF8FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleteIcon);
export default __webpack_public_path__ + "static/media/complete-icon.ba9d09ac4a5c995cc9e5c7d63ef8652f.svg";
export { ForwardRef as ReactComponent };